import { render, staticRenderFns } from "./DashboardMeal.vue?vue&type=template&id=c5de1636&scoped=true"
import script from "./DashboardMeal.vue?vue&type=script&lang=js"
export * from "./DashboardMeal.vue?vue&type=script&lang=js"
import style0 from "./DashboardMeal.vue?vue&type=style&index=0&id=c5de1636&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5de1636",
  null
  
)

export default component.exports